import axios from 'axios';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// api
import ApiKey from 'Components/api/ApiKey';
import BaseApi from 'Components/api/BaseApi';
// components
import SmallLoading from 'Components/element/SmallLoading';
import CVDescription from 'Components/element/CVDescription';
// helpers
import { logOutIfTokenExpired, resultInfo } from 'Components/helpers';
import { useWindowSize } from 'Hooks/use-window-size';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

import { AddToFavorites, FavoritesStore } from '../../feature-add-to-favorite';
import { Container, Flex, Spinner } from '@radix-ui/themes';

export const ViewCV = () => {
   const { id } = useParams();
   const navigate = useNavigate();
   const { width } = useWindowSize();
   const { t } = useTranslation('global');
   const userType = Cookies.get('user_type');
   const tokenKey = Cookies.get('tokenClient');

   const [addToFavoriteStore] = useState(() => new FavoritesStore());

   const [loading, setLoading] = useState(true);
   const [cvDetails, setCvDetails] = useState({});
   const [smallLoading, setSmallLoading] = useState(false);

   const { fav_status, candidate_id } = cvDetails;

   const getData = async () => {
      try {
         setLoading(true);

         const response = await axios.post(
            BaseApi + '/candidates/getCv',
            { id },
            {
               headers: {
                  key: ApiKey,
                  token: tokenKey,
                  contentType: 'application/json',
               },
            }
         );

         setLoading(false);

         if (response.data.status === 200) {
            setCvDetails(response.data.response);
         } else if (response.data.status === 400) {
            navigate('/');

            Cookies.remove('fname');
            Cookies.remove('user_id');
            Cookies.remove('user_type');
            Cookies.remove('tokenClient');

            resultInfo('warning', response.data.message, t('jobseekerManageAlert.close'));
         } else {
            resultInfo('error', response.data.message, t('jobseekerManageAlert.close'));
         }
      } catch (error) {
         setLoading(false);

         if (
            error.message === 'Network Error' ||
            error.response.data.message === 'Token has expired'
         ) {
            navigate('/');

            logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
         }

         console.error('Cannot get profile data', error);
      }
   };

   const handleDownloadResume = async () => {
      try {
         setSmallLoading(true);

         const response = await axios.post(
            BaseApi + '/download-user-pdf',
            {
               id,
               contacts: false,
            },
            {
               responseType: 'blob',
               headers: {
                  key: ApiKey,
                  token: tokenKey,
               },
            }
         );

         setSmallLoading(false);

         const url = window.URL.createObjectURL(response.data);
         const filename = response.headers['content-disposition']
            ? response.headers['content-disposition'].split('filename=')[1]
            : 'resume-grc.pdf';

         const link = document.createElement('a');
         link.href = url;
         link.setAttribute('download', filename.replace(/['"]/g, ''));
         document.body.appendChild(link);
         link.click();
         window.URL.revokeObjectURL(url);
         document.body.removeChild(link);
      } catch (error) {
         setSmallLoading(false);

         if (error.response.status === 400) {
            resultInfo(
               'warning',
               t('jobseekerManageAlert.contactsError'),
               t('jobseekerManageAlert.close')
            );
         } else {
            resultInfo(
               'error',
               t('jobDescription.unsubscribeError'),
               t('jobseekerManageAlert.close')
            );
         }

         console.error('Cannot download resume', error);
      }
   };

   useEffect(() => {
      if (userType === 'candidate' || !tokenKey) {
         navigate('/auth/candidate-login');
      } else {
         getData();
         window.scrollTo(0, 0);
      }
   }, [tokenKey, navigate, userType]); // eslint-disable-line


    if (loading) {
      return (
         <Container>
            <Flex justify="center" align="center" height="516px">
               <Spinner size="3"></Spinner>
            </Flex>
         </Container>
      );
   }

   return (
      <>
         {loading ? (
            <div className="loader-container"></div>
         ) : (
            <>
               <div className="container my-5 JSMyCV">
                  <div className="row">
                     <div className="col cheaps">
                        <AddToFavorites
                           store={addToFavoriteStore}
                           candidateId={candidate_id}
                           cvId={id}
                           disabled={fav_status === 1}
                           favoriteInfo={{ type: 'cv', from_cv_database: 1 }}
                           refetch={()=> getData()}
                        />

                        <button
                           type="button"
                           disabled={smallLoading}
                           className="btn btn-primary button1"
                           onClick={() => handleDownloadResume()}
                        >
                           <FileDownloadOutlinedIcon />{' '}
                           {width >= 768 && t('cvDescription.downloadPDF')}{' '}
                           {smallLoading && (
                              <SmallLoading width="24px" height="24px" color="#FFFFFF" />
                           )}
                        </button>
                     </div>
                  </div>
                  <CVDescription cvDetails={cvDetails} />
               </div>
            </>
         )}
      </>
   );
};

export default ViewCV;
